import * as React from "react";
import { useCallback } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useStoreSystem } from "../../../store";
import shallow from "zustand/shallow";
import { styled, TextField, TextFieldProps } from "@mui/material";
import { useAlerts } from "../../../hooks/useAlerts";
import CloseButton from "../../shared/ui/CloseButton/CloseButton";

const HashField = styled((props: TextFieldProps) => <TextField disabled {...props} />)(({ theme }) => ({
    backgroundColor: "rgba(164,164,164,0.31)",
    width: "100%",
    marginRight: theme.spacing(4),
    input: { color: theme.palette.primary.main },
    "& .MuiFormLabel-root": {
        margin: theme.spacing(-2, -1.5),
        fontSize: 18,
        color: "#838280",
    },
    "& .Mui-disabled": {
        webkitTextFillColor: "initial",
    },
}));

export function SavedProjectModal() {
    const { savedProjectModal, setSavedProjectModal } = useStoreSystem(
        (state) => ({
            savedProjectModal: state.savedProjectModal,
            setSavedProjectModal: state.setSavedProjectModal,
        }),
        shallow
    );
    const { addReadyAlert } = useAlerts();

    const handleClose = useCallback(() => {
        setSavedProjectModal(false, "");
    }, []);

    const onCopyHandler = useCallback(async () => {
        await navigator.clipboard.writeText(window.location.toString());
        addReadyAlert("Ссылка сохранена в буфер обмена", "success", 1500);
    }, []);

    return (
        <Dialog open={savedProjectModal.isOpen} onClose={handleClose}>
            <CloseButton style={{ top: "22px", right: "24px" }} onClick={handleClose} />
            <DialogTitle>{"Сохранение проекта"}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Проект успешно {savedProjectModal.isRewrite ? "обновлен" : "сохранен"}, скопируйте код или сслыку
                    для повторного открытия проекта
                </DialogContentText>
            </DialogContent>
            <div style={{ padding: "16px 24px", display: "flex", justifyContent: "space-between" }}>
                <HashField label="Ссылка на проект" value={window.location} />
                <Button variant="contained" autoFocus onClick={onCopyHandler} sx={{ pl: 3, pr: 3 }}>
                    Скопировать
                </Button>
            </div>
        </Dialog>
    );
}
